import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export type ConfirmUserCall = (
  userID: number,
  token: string,
) => Promise<{ data: null }>;

export default (makeCall: MakeCall) => (userID: number, token: string) =>
  makeCall<null>('PUT', `${APIV2_URL}/user/${userID}/confirm`, {
    data: { token },
  });
